import { getImageUrl } from '@ego/api';

/**
 * Group block preview rows by channel ID, keeping at most `max` per channel.
 * Returns a map of channelId → preview objects.
 */
export function groupBlockPreviews(previewBlocks, max = 3) {
  const byChannel = {};
  for (const block of previewBlocks) {
    if (!byChannel[block.channelId]) byChannel[block.channelId] = [];
    if (byChannel[block.channelId].length < max) {
      byChannel[block.channelId].push({
        type: block.type,
        imageUrl: block.imagePath ? getImageUrl(block.imagePath) : null,
        content: block.content,
      });
    }
  }
  return byChannel;
}

/**
 * Pad a previews array with null entries so it always has `count` items.
 */
export function padPreviews(previews, count = 3) {
  const result = [...previews];
  while (result.length < count) result.push(null);
  return result;
}
